import axios from 'axios'
import {call, put, takeEvery, takeLatest} from 'redux-saga/effects'
import * as actions from '../actions/'
import {
  ACCESS_TOKEN,
  LOAD_COURSE_USER_DATA,
  LOAD_COURSES_DATA,
  LOAD_PROGRAMMES_DATA,
  LOAD_PROGRAMMES_DATA_BY_ID,
  LOAD_ROLES_DATA,
  LOAD_SECTION_DATA,
  LOAD_TERMS_DATA,
  LOAD_USER_DATA,
  SIS_POST_ENROLLMENTS,
  SIS_STATUS,
  UPLOAD_REQUEST
} from '../constants/action-types'
import {buffers, END, eventChannel} from 'redux-saga'
import BrowserStore from 'store'

let inseadCanvasAdmin = BrowserStore.get('inseadCanvasAdmin')

const config = {
  headers: {
    Authorization: `Bearer ${
      inseadCanvasAdmin ? inseadCanvasAdmin.access_token : ''
    }`
  }
}

const API_HOST = process.env.REACT_APP_CANVAS_API_HOST
const SURVEY_ID = process.env.REACT_APP_BEST_TEACHING_SURVEY_ID

function* loadProgrammesData(action) {
  let baseUrl = 'api/v1/accounts/1/sub_accounts?per_page=100&page=1&'

  let payload = {
    url: baseUrl,
    header: config.headers,
    type: 'GET'
  }

  baseUrl = 'api/canvas/invoke?'

  if (inseadCanvasAdmin.sub_account.perm === 'ALL') {
    const response = yield axios.post(`${API_HOST}${baseUrl}`, payload, config)
    yield put(actions.loadProgrammesDataSuccess(response.data, action.key))
  }

  if (inseadCanvasAdmin.sub_account.perm === 'CUSTOM') {
    yield put(
      actions.loadProgrammesDataSuccess(
        inseadCanvasAdmin.sub_account.sub_accounts,
        ''
      )
    )
  }
}

export function* watchProgrammesData() {
  yield takeEvery(LOAD_PROGRAMMES_DATA, loadProgrammesData)
}

function* loadProgrammesDataByID(action) {
  let baseUrl = `api/v1/accounts/${action.payload}/sub_accounts?per_page=100&page=1&recursive=true&`

  let payload = {
    url: baseUrl,
    header: config.headers,
    type: 'GET'
  }

  baseUrl = 'api/canvas/invoke?'

  const response = yield axios.post(`${API_HOST}${baseUrl}`, payload, config)

  let finalSubAccounts = response.data.map((option) => {
    const getParentData = response.data.filter(
      (fil) => fil.id === option.parent_account_id
    )
    let parentData = ''
    let parent_name = 'MAIN'

    if (getParentData.length != 0) {
      parentData = getParentData[0]
      parent_name = parentData.name
    }

    // programsByIdParentNames.push(parent_name)

    return {
      parent_name: parent_name,
      ...option
    }
  })

  finalSubAccounts.sort((a, b) => parseFloat(a.id) - parseFloat(b.id))

  yield put(actions.loadProgrammesDataByIDSuccess(finalSubAccounts, ''))
}

export function* watchProgrammesDataByID() {
  yield takeEvery(LOAD_PROGRAMMES_DATA_BY_ID, loadProgrammesDataByID)
}

function* loadTermsData(action, page = 1) {
  let baseUrl = 'api/v1/accounts/1/terms?per_page=100&page=' + page + '&'

  let payload = {
    url: baseUrl,
    header: config.headers,
    type: 'GET'
  }

  baseUrl = 'api/canvas/invoke?'

  let response = yield axios.post(`${API_HOST}${baseUrl}`, payload, config)

  let loading = false

  if (response.data.enrollment_terms.length != 0) {
    loading = true
  } else {
    loading = false
  }

  let filter = response.data.enrollment_terms.filter(
    (data) => data != null && data.name !== null
  )

  yield put(
    actions.loadTermsDataSuccess({
      enrollment_terms: [...filter],
      loading: loading
    })
  )

  if (response.data.enrollment_terms.length != 0) {
    let p = page + 1
    yield* loadTermsData(action, p)
  }
}

export function* watchTermsData() {
  yield takeEvery(LOAD_TERMS_DATA, loadTermsData)
}

function* putState(value) {
  yield put(actions.loadCoursesDataStart(value))
}

function* loadCoursesData(action, page = 1, loading = true) {
  // let baseUrl = "api/v1/accounts/" + action.payload.programme + "/courses?per_page=100&page=1&enrollment_term_id=" + action.payload.term + "&";

  let baseUrl =
    'api/v1/accounts/' +
    action.payload.programme +
    '/courses?per_page=100&page=' +
    page +
    '&include[]=term&'

  let queryString = 'params=' + baseUrl

  let payload = {
    url: baseUrl,
    header: config.headers,
    type: 'GET'
  }

  baseUrl = 'api/canvas/invoke?'

  yield put(actions.loadCoursesDataStart(true))

  const response = yield axios.post(
    `${API_HOST}${baseUrl}${queryString}`,
    payload,
    config
  )

  let course = response.data.map((option) => {
    const sis_course_id = option.sis_course_id
    let campus = ''

    if (sis_course_id === null) {
      campus = 'Manually Created'
    } else {
      campus = sis_course_id.split('-')[1]
    }

    return {
      campus: campus,
      page_number: page,
      ...option
    }
  })

  let isNext = nextURL(response.headers.link)
  // let loading = false;

  if (isNext !== null) {
    loading = true
  } else {
    loading = false
  }

  yield put(
    actions.loadCoursesDataSuccess(
      course,
      { programme: action.payload.programme, page: page },
      loading
    )
  )

  if (isNext !== null) {
    let p = page + 1
    yield* loadCoursesData(action, p, true)
  }
}

function nextURL(linkTxt) {
  var url = null
  if (linkTxt) {
    var links = linkTxt.split(',')
    var nextRegEx = new RegExp('^<(.*)>; rel="next"$')
    for (var i = 0; i < links.length; i++) {
      var matches = nextRegEx.exec(links[i])
      if (matches) {
        url = matches[1]
      }
    }
  }
  return url
}

export function* watchCoursesData() {
  yield takeEvery(LOAD_COURSES_DATA, loadCoursesData)
}

function* loadRolesData(action) {
  let baseUrl = 'api/v1/accounts/1/roles?per_page=100&'

  let payload = {
    url: baseUrl,
    header: config.headers,
    type: 'GET'
  }

  baseUrl = 'api/canvas/invoke?'

  const response = yield axios.post(
    `${API_HOST}${baseUrl}${action.payload}`,
    payload,
    config
  )
  yield put(actions.loadRolesDataSuccess(response.data, action.key))
}

export function* watchRolesData() {
  yield takeLatest(LOAD_ROLES_DATA, loadRolesData)
}

function* loadUsersData(action) {
  let baseUrl = 'api/v1/accounts/1/users?search_term=' + action.payload

  let payload = {
    url: baseUrl,
    header: config.headers,
    type: 'GET'
  }

  baseUrl = 'api/canvas/invoke?'

  const response = yield axios.post(`${API_HOST}${baseUrl}`, payload, config)
  yield put(actions.loadUserDataSuccess(response.data, action.key))
}

export function* watchUsersData() {
  yield takeEvery(LOAD_USER_DATA, loadUsersData)
}

function* trackUser(action, executedFrom, uploadedCsv = '') {
  let baseUrl = 'api/auth/log-status'

  let link = ''

  if (uploadedCsv != '') {
    link = '<a href="' + uploadedCsv + '">Uploaded CSV</a>'
  }

  let payload = {
    email: inseadCanvasAdmin.sub_account.email,
    id: action.toString() + ' - ' + link + ' - ' + executedFrom
  }

  // baseUrl = 'api/canvas/invoke?';

  const response = axios.post(`${API_HOST}${baseUrl}`, payload)
}

function* postEnrollmentsData(action) {
  let baseUrl = 'api/v1/accounts/1/sis_imports?override_sis_stickiness=true'

  let payload = {
    url: baseUrl,
    header: {
      Authorization: config.headers.Authorization,
      'Content-Type': 'text/plain'
    },
    type: 'POST_SIS',
    payload: action.payload.join('\n')
  }

  baseUrl = 'api/canvas/invoke?'

  const response = yield axios.post(`${API_HOST}${baseUrl}`, payload)

  let uploadCsvUrl = ''

  // const track = yield trackUser(response.data.id, 'Course Level Admin')

  yield put(actions.postEnrollmentsSuccess(response.data, action.key))
}

export function* watchPostEnrollmentsData() {
  yield takeEvery(SIS_POST_ENROLLMENTS, postEnrollmentsData)
}

export async function getSISImportStatus(importID, segmentName = '') {
  let baseUrl = '/api/v1/accounts/1/sis_imports/' + importID

  let payload = {
    url: baseUrl,
    header: config.headers,
    type: 'GET'
  }

  baseUrl = 'api/canvas/invoke?'

  const response = await axios.post(`${API_HOST}${baseUrl}`, payload, config)

  let uploadCsvUrl = ''

  // console.log(response.data)

  if (response.data.workflow_state == 'imported') {
    if (typeof response.data.csv_attachments[0] != 'undefined') {
      if (typeof response.data.csv_attachments[0].url != 'undefined') {
        uploadCsvUrl = response.data.csv_attachments[0].url
      }
    }

    const track = await trackUserFiles(
      response.data.id,
      segmentName + ' :: SIS Status check API - success',
      uploadCsvUrl
    )
  } else if (response.data.workflow_state == 'imported_with_messages') {
    const track = await trackUserFiles(
      response.data.id,
      segmentName + ' :: SIS Status check API - error',
      response.data.errors_attachment.url
    )
  }

  return response.data
}

export function sendEmail(action, data) {
  let baseUrl = 'api/auth/send-email'

  let payload = {
    emailType: action.toString(),
    dataSet: data,
    requestedBy: inseadCanvasAdmin.sub_account.email
  }

  const response = axios.post(`${API_HOST}${baseUrl}`, payload)
}

async function trackUserFiles(action, executedFrom, uploadedCsv = '') {
  let baseUrl = 'api/auth/log-status'

  let link = ''

  if (uploadedCsv != '') {
    link = '<a href="' + uploadedCsv + '">Uploaded CSV</a>'
  }

  let payload = {
    email: inseadCanvasAdmin.sub_account.email,
    id: action.toString() + ' - ' + link + ' - ' + executedFrom
  }

  // baseUrl = 'api/canvas/invoke?';

  const response = axios.post(`${API_HOST}${baseUrl}`, payload)
}

export async function updateSectionSISID(action, data) {
  let baseUrl = '/api/v1/sections/' + action

  let payload = {
    url: baseUrl,
    header: config.headers,
    type: 'PUT',
    payload: data
  }

  baseUrl = 'api/canvas/invoke?'

  // baseUrl = 'api/canvas/invoke?';

  const response = await axios.post(`${API_HOST}${baseUrl}`, payload)

  console.log(response)
}

function* getSISStatus(action, req = null) {
  if (req === 'imported' || req === 'imported_with_messages') {
    return false
  }

  let baseUrl = '/api/v1/accounts/1/sis_imports/' + action.payload

  let payload = {
    url: baseUrl,
    header: config.headers,
    type: 'GET'
  }

  baseUrl = 'api/canvas/invoke?'

  const response = yield axios.post(`${API_HOST}${baseUrl}`, payload, config)

  let uploadCsvUrl = ''

  if (response.data.workflow_state == 'imported') {
    if (typeof response.data.csv_attachments[0] != 'undefined') {
      if (typeof response.data.csv_attachments[0].url != 'undefined') {
        uploadCsvUrl = response.data.csv_attachments[0].url
      }
    }

    const track = yield trackUser(
      response.data.id,
      ' SIS Status check API - success',
      uploadCsvUrl
    )
  } else if (response.data.workflow_state == 'imported_with_messages') {
    const track = yield trackUser(
      response.data.id,
      ' SIS Status check API - error',
      response.data.errors_attachment.url
    )
  }

  yield put(actions.getSISStatusSuccess(response.data, ''))
}

export function* watchSISStatusData() {
  yield takeLatest(SIS_STATUS, getSISStatus)
}

//

function* getAccessToken(action) {
  let baseUrl = '/login/oauth2/token'

  let dataSet = {
    grant_type: 'authorization_code',
    client_id: '',
    client_secret: '',
    redirect_uri: '',
    code: ''
  }

  const response = yield axios.post(
    `${API_HOST}${baseUrl}${action.payload}`,
    dataSet
  )
  yield put(actions.getAccessTokenSuccess(response.data, ''))
}

export function* watchAccessToken() {
  yield takeLatest(ACCESS_TOKEN, getAccessToken)
}

function createUploadFileChannel(endpoint, file, payload) {
  return eventChannel((emitter) => {
    const xhr = new XMLHttpRequest()
    const onProgress = (e) => {
      if (e.lengthComputable) {
        const progress = e.loaded / e.total
        emitter({ progress })
      }
    }
    const onFailure = (e) => {
      emitter({ err: new Error('Upload failed') })
      emitter(END)
    }
    xhr.upload.addEventListener('progress', onProgress)
    xhr.upload.addEventListener('error', onFailure)
    xhr.upload.addEventListener('abort', onFailure)
    xhr.onreadystatechange = () => {
      const { readyState, status, responseText } = xhr
      if (readyState === 4) {
        if (status === 200) {
          emitter({ success: true, response: responseText })
          emitter(END)
        } else {
          onFailure(null)
        }
      }
    }
    xhr.open('POST', endpoint)

    let baseUrl = 'api/v1/accounts/1/sis_imports'

    var formData = new FormData()
    formData.append('url', baseUrl)
    formData.append('header', JSON.stringify(config.headers))
    formData.append('file', file)

    xhr.setRequestHeader('Authorization', config.headers.Authorization)
    // xhr.setRequestHeader('Accept', 'application/json, text/plain, */*');
    // xhr.setRequestHeader('Content-Type',  'multipart/form-data');

    let jjson = {
      url: baseUrl,
      header: config.headers,
      type: 'FILE'
    }

    xhr.send(formData)

    return () => {
      xhr.upload.removeEventListener('progress', onProgress)
      xhr.upload.removeEventListener('error', onFailure)
      xhr.upload.removeEventListener('abort', onFailure)
      xhr.onreadystatechange = null
      xhr.abort()
    }
  }, buffers.sliding(2))
}

// Watch for an upload request and then
// defer to another saga to perform the actual upload
export function* uploadRequestWatcherSaga() {
  yield takeEvery(UPLOAD_REQUEST, function* (action) {
    const file = action.payload
    yield call(uploadFileSaga, file)
  })
}
// Upload the specified file
export function* uploadFileSaga(file) {
  let baseUrl = 'api/v1/accounts/1/sis_imports'

  baseUrl = 'api/canvas/sis-import?'

  const channel = yield call(
    createUploadFileChannel,
    `${API_HOST}${baseUrl}`,
    file
  )
  while (true) {
    const { progress = 0, err, success, response } = yield take(channel)
    if (err) {
      yield put(actions.uploadFailure(file, err))
      return
    }
    if (success) {
      let json = JSON.parse(response)

      let uploadCsvUrl = ''

      const track = yield trackUser(json.id, 'SIS Import', uploadCsvUrl)

      yield put(actions.uploadSuccess(response))
      return
    }

    yield put(actions.uploadProgress(file, progress))
  }
}

export function deleteLoggedInToken(action) {
  let baseUrl = '/login/oauth2/token'

  let payload = {
    url: baseUrl,
    header: config.headers,
    type: 'DELETE'
  }

  baseUrl = 'api/canvas/invoke?'

  const response = axios.post(`${API_HOST}${baseUrl}`, payload)
}

function* loadSectionDataByID(action) {
  let baseUrl = `api/v1/courses/${action.payload}/sections?per_page=100&`

  let payload = {
    url: baseUrl,
    header: config.headers,
    type: 'GET'
  }

  baseUrl = 'api/canvas/invoke?'

  const response = yield axios.post(`${API_HOST}${baseUrl}`, payload, config)

  let output = {}

  let longestSectionNameLength = Math.max(
    ...response.data.map((el) => el.name.length)
  )
  let adminTag = response.data.map((option, i) => {
    //new logic is, find admin tag based on the char count.
    if (longestSectionNameLength === option.name.length) {
      option.name = `${option.name}`
    }

    return {
      ...option
    }
  })

  output[action.payload] = adminTag

  yield put(actions.loadSectionDataSuccess(output, action.payload))
}

export function* watchLoadSectionDataByID() {
  yield takeEvery(LOAD_SECTION_DATA, loadSectionDataByID)
}

export async function uploadS3ZoomEvent(action) {
  let baseUrl = ''

  let payload = {
    courseId: action.courseId,
    requestedBy: action.requestedBy,
    daysCount: action.daysCount
  }

  var queryString = Object.keys(payload)
    .map((key) => key + '=' + payload[key])
    .join('&')
  baseUrl = 'api/auth/zoom-s3-course-update?' + queryString

  const response = await axios.get(`${API_HOST}${baseUrl}`, payload, config)
  let output = {}

  return response.data
}

export const uploadFile = async (file) => {
  try {
    // console.log("Upload Image", file);
    // const formData = new FormData();
    // formData.append("file", file);
    // const config = {
    //   headers: {
    //     "content-type": "multipart/form-data"
    //   }
    // };

    let formData = {
      data: file
    }

    const url = `${API_HOST}api/aws/aws-upload`
    const result = await axios.post(url, formData, config)

    return result.data

    // console.log("REsult: ", result);
  } catch (error) {
    console.error(error)
  }
}

//////////////////////////////////
/////////////////////////////////

export async function createGroupCategory(action) {
  let baseUrl = `/api/v1/courses/${action.courseID}/group_categories`

  let payload = {
    url: baseUrl,
    header: config.headers,
    type: 'POST',
    payload: action.payload
  }

  baseUrl = 'api/canvas/invoke?'
  const response = await axios.post(`${API_HOST}${baseUrl}`, payload, config)
  return response
}

export async function loadGroupCategories(action) {
  let baseUrl = `/api/v1/courses/${action.courseID}/group_categories?per_page=100`

  let payload = {
    url: baseUrl,
    header: config.headers,
    type: 'GET'
  }

  baseUrl = 'api/canvas/invoke?'
  const response = await axios.post(`${API_HOST}${baseUrl}`, payload, config)

  return response
}

function* loadCoursesUsers(action, page = 1, loading = true) {
  let baseUrl =
    'api/v1/courses/' +
    action.payload.courseId +
    '/users?per_page=100&page=' +
    page +
    '&enrollment_type[]=student&include[]=enrollments&'
  let queryString = ''

  let payload = {
    url: baseUrl,
    header: config.headers,
    type: 'GET'
  }

  baseUrl = 'api/canvas/invoke?'

  yield put(actions.loadCoursesDataStart(true))

  const response = yield axios.post(
    `${API_HOST}${baseUrl}${queryString}`,
    payload,
    config
  )
  let users = response
  let isNext = response.data.length //nextURL(response.headers.link)

  if (isNext != 0) {
    loading = true
  } else {
    loading = false
  }

  yield put(
    actions.loadCoursesUserDataSuccess(
      users.data,
      { courseId: action.payload.courseId, page: page },
      loading
    )
  )

  if (isNext != 0) {
    let p = page + 1
    yield* loadCoursesUsers(action, p, true)
  }
}

export function* watchCourseStudentsData() {
  yield takeEvery(LOAD_COURSE_USER_DATA, loadCoursesUsers)
}

export async function getCourseDetails(courseID) {
  let baseUrl = `/api/v1/courses/${courseID}?include[]=total_students&include[]=sections`

  let payload = {
    url: baseUrl,
    header: config.headers,
    type: 'GET'
  }

  baseUrl = 'api/canvas/invoke?'
  const response = await axios.post(`${API_HOST}${baseUrl}`, payload, config)
  return response
}

export async function getBestTeachingData(courseType, campus) {
  const baseUrl = `${process.env.REACT_APP_BEST_TEACHING_BASE_URL_API}/best-teaching-reports/api/`
  const subUrl =
    campus == 'Prof'
      ? `by-prof/${courseType}`
      : `${courseType}-courses/${campus}`

  const payload = {
    url: baseUrl,
    header: config.headers,
    type: 'GET'
  }

  const response = await axios.get(`${baseUrl}${subUrl}`, payload, config)
  return response.data
}

export async function getBestTeachingStats() {
  const baseUrl = `${process.env.REACT_APP_BEST_TEACHING_BASE_URL_API}/best-teaching-reports/api/stats/`

  const payload = {
    url: baseUrl,
    header: config.headers,
    type: 'GET'
  }

  const response = await axios.get(`${baseUrl}`, payload, config)
  return response.data
}

export async function updateBestTeachingData() {
  const baseUrl = `${process.env.REACT_APP_BEST_TEACHING_BASE_URL_API}/best-teaching-reports/api/refresh-qualtrics/`

  const payload = {
    url: baseUrl,
    header: config.headers,
    type: 'GET'
  }

  const response = await axios.get(`${baseUrl}${SURVEY_ID}`, payload, config)
  return response.data
}

export async function getZoomQueueCourses(courseID) {
  const baseUrl = 'api/auth/zoom-s3-course-queue-data'
  let payload = {}
  const response = await axios.get(`${API_HOST}${baseUrl}`, payload, config)
  return response.data
}

export async function updateZoomQueueCourses(action) {
  let baseUrl = ''
  let payload = {
    courseIds: action.courseIds,
    requestedBy: action.requestedBy,
    daysCount: action.daysCount
  }

  baseUrl = 'api/auth/zoom-s3-course-queue-update?'
  const response = await axios.post(`${API_HOST}${baseUrl}`, payload, config)

  return response.data
}

export async function getSearchUsers(text) {
  let baseUrl = 'api/v1/accounts/1/users?search_term=' + text

  let payload = {
    url: baseUrl,
    header: config.headers,
    type: 'GET'
  }

  baseUrl = 'api/canvas/invoke?'

  const response = await axios.post(`${API_HOST}${baseUrl}`, payload, config)
  return response
}

export async function getCourseDetailsWithIncludes(courseID) {
  let baseUrl = `/api/v1/courses/${courseID}?include[]=sections`

  let payload = {
    url: baseUrl,
    header: config.headers,
    type: 'GET'
  }

  baseUrl = 'api/canvas/invoke?'
  const response = await axios.post(`${API_HOST}${baseUrl}`, payload, config)
  return response
}

export async function getZoomEvents(
  courseID,
  page = 1,
  perPage = 5,
  receivedData = null,
  startDate,
  endDate
) {
  const d = new Date()
  let ms = d.getMilliseconds()

  let payloadRequest = `/internal/lms/zoom/calendar_events?page=${page}&per_page=100&type=event&context_codes[]=course_${courseID}&excludes[]=assignment&start_date=${startDate}&end_date=${endDate}&insead_t=${ms}`

  let payload = {
    url: payloadRequest,
    header: config.headers,
    type: 'GET'
  }

  let baseUrl = 'api/passthrough/invoke?'

  const response = await axios.post(`${API_HOST}${baseUrl}`, payload, config)

  let isNext = response.data.pagination.nextPage // nextURL(response.headers.link)
  let loading = false
  // let loading = false;

  console.log('saga')
  console.log(isNext)

  if (isNext !== 0) {
    loading = true
  } else {
    loading = false
  }

  let dataSet = [...response.data.data]

  // console.log(dataSet)

  if (receivedData !== null) {
    dataSet = [...dataSet.concat(receivedData)]
  }

  if (isNext !== 0) {
    let p = page + 1
    return await getZoomEvents(
      courseID,
      p,
      perPage,
      dataSet,
      startDate,
      endDate
    )
  }

  return dataSet
}

export async function updateZoomOwner(data) {
  try {
    const d = new Date()
    let ms = d.getMilliseconds()

    let payloadRequest = `/internal/lms/zoom/update_owner/?t=${ms}`

    let payload = {
      url: payloadRequest,
      header: config.headers,
      payload: {
        reservation_id: data.reservation_id,
        zoom_owner: data.host,
        zoom_alternative_host: data.coHost,
        visibility: data.visibility,
        zoom_meeting_created: data.zoom_meeting_created,
        calendar_event: data.calendar_event
      },
      type: 'POST'
    }

    let baseUrl = 'api/passthrough/invoke?'

    return await axios.post(`${API_HOST}${baseUrl}`, payload, config)
  } catch (err) {
    console.log('update zoom owner error',err)
  }
}

export async function getMySchedulers() {
  try {
    const d = new Date()
    let ms = d.getMilliseconds()

    let payloadRequest = `/internal/lms/zoom/:my_email:/schedulers`

    let payload = {
      url: payloadRequest,
      header: config.headers,
      type: 'GET'
    }

    let baseUrl = 'api/passthrough/invoke?'

    const response = await axios.post(`${API_HOST}${baseUrl}`, payload, config)

    return response
  } catch (e) {
    console.log('pakaya')
  }
}

export async function getSingleCourseDetails(courseID) {
  let baseUrl = `/api/v1/courses/${courseID}`

  let payload = {
    url: baseUrl,
    header: config.headers,
    type: 'GET'
  }

  baseUrl = 'api/canvas/invoke?'
  const response = await axios.post(`${API_HOST}${baseUrl}`, payload, config)
  return response
}

export async function updateMergeEvents(data) {
  const d = new Date()
  let ms = d.getMilliseconds()

  let payloadRequest = `/internal/lms/zoom/merge_events/?t=${ms}`

  let payload = {
    url: payloadRequest,
    header: config.headers,
    payload: data,
    type: 'POST'
  }

  let baseUrl = 'api/passthrough/invoke?'

  const response = await axios.post(`${API_HOST}${baseUrl}`, payload, config)

  return response
}

export async function unMergeEvents(data) {
  const d = new Date()
  let ms = d.getMilliseconds()

  let payloadRequest = `/internal/lms/zoom/un_merge_event/?t=${ms}`

  let payload = {
    url: payloadRequest,
    header: config.headers,
    payload: data,
    type: 'POST'
  }

  let baseUrl = 'api/passthrough/invoke?'

  const response = await axios.post(`${API_HOST}${baseUrl}`, payload, config)

  return response
}

export async function loadGroupCategoriesGroups(
  groupId,
  page = 1,
  receivedData = null
) {
  let baseUrl = `/api/v1/group_categories/${groupId}/groups?per_page=100&page=${page}`

  let payload = {
    url: baseUrl,
    header: config.headers,
    type: 'GET'
  }

  baseUrl = 'api/canvas/invoke?'
  const response = await axios.post(`${API_HOST}${baseUrl}`, payload, config)

  let isNext = response.data.length
  let loading = false

  console.log('saga')
  console.log(isNext)

  if (isNext !== 0) {
    loading = true
  } else {
    loading = false
  }

  let dataSet = [...response.data]

  if (receivedData !== null) {
    dataSet = [...dataSet.concat(receivedData)]
  }

  if (isNext !== 0) {
    let p = page + 1
    return await loadGroupCategoriesGroups(groupId, p, dataSet)
  }

  return dataSet
}

export async function loadGroupMemberships(
  groupId,
  page = 1,
  receivedData = null
) {
  let baseUrl = `/api/v1/groups/${groupId}/memberships?per_page=100&page=${page}`

  let payload = {
    url: baseUrl,
    header: config.headers,
    type: 'GET'
  }

  baseUrl = 'api/canvas/invoke?'
  const response = await axios.post(`${API_HOST}${baseUrl}`, payload, config)

  let isNext = response.data.length
  let loading = false

  console.log('saga')
  console.log(isNext)

  if (isNext !== 0) {
    loading = true
  } else {
    loading = false
  }

  let dataSet = [...response.data]

  if (receivedData !== null) {
    dataSet = [...dataSet.concat(receivedData)]
  }

  if (isNext !== 0) {
    let p = page + 1
    return await loadGroupMemberships(groupId, p, dataSet)
  }

  return dataSet
}

/**
 * Save best teaching award method
 */
export async function saveBestTeachingAwardFromUploadRequest(data) {
  console.log('data', data)
  const baseUrl = `${process.env.REACT_APP_BEST_TEACHING_BASE_URL_API}/best-teaching-reports/api/import/excel`
  const payload = {
    data,
    url: baseUrl,
    header: config.headers,
    type: 'POST'
  }
  return axios.post(`${baseUrl}`, payload.data, {
    headers: {
      'content-type': 'application/json'
    }
  })
}
